import Const from 'constants';
import Action from 'actions';

let CompetitionStacking = {
    useCompetitionStacking(use, competitionType) {
        return {
            type: Const.COMPETITION_STACKING_SET_IS_USED,
            use,
            competitionType,
        };
    },

    addItemToCompetitionStacking() {
        return {
            type: Const.COMPETITION_STACKING_ADD_ITEM,
        };
    },

    setCompetition(itemId, competition) {
        return {
            type: Const.COMPETITION_STACKING_SET_COMPETITION,
            itemId,
            competition: competition,
        };
    },

    setExposure(itemId, value) {
        return {
            type: Const.COMPETITION_STACKING_SET_EXPOSURE,
            itemId,
            value,
        };
    },

    removeItemOfCompetitionStacking(itemId) {
        return {
            type: Const.COMPETITION_STACKING_REMOVE_ITEM,
            itemId,
        };
    },
};

export default Object.assign(Action, CompetitionStacking);
